export const color = {
  // Main colors
  primary: '#FAA321',
  secondary: '#0F1B4A',

  // Font colors
  black: '#000000',
  disabled: '#6d7070',
};
